/* Healthy Millet Recipes: the page's own behaviour.
   The engine (ScrollCraft) pins, pans, cues and publishes --sc-p on each act.
   Everything bespoke lives here: the layered hero, the thumb index, the millet
   picker, and the riffle through every dish in the set. */
(function () {
  'use strict';
  var root = document.getElementById('msx');
  if (!root || !window.ScrollCraft) return;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var mode = root.getAttribute('data-msx-mode');
  var sheetsCdn = mode === 'cdn' ? JSON.parse(root.getAttribute('data-msx-sheets') || '{}') : null;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var clamp01 = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var vh = innerHeight, vw = innerWidth;

  // the store header sits above the hero; size the hero to what is left
  function headerOffset() {
    var h = document.getElementById('shopify-section-header');
    root.style.setProperty('--msx-hdr', (h ? h.offsetHeight : 0) + 'px');
  }
  headerOffset();

  // With motion reduced the shelf is not pinned and panned: it is a plain grid
  // in the page flow, so nothing holds still under the reader's hand.
  if (reduce) {
    var sh = document.getElementById('msx-shelf'), rl = sh && sh.querySelector('[data-sc-pan]');
    if (sh) { sh.setAttribute('data-sc-act', 'flow'); sh.removeAttribute('data-sc-span'); sh.classList.add('is-grid'); }
    if (rl) rl.removeAttribute('data-sc-pan');
  }
  var sc = ScrollCraft.mount(root);
  // the store header and anything apps add above the section can change height
  // after the engine has measured; re-measure when they do
  var hdr = document.getElementById('shopify-section-header');
  if (hdr && 'ResizeObserver' in window) new ResizeObserver(function () { headerOffset(); sc.layout(); }).observe(hdr);
  addEventListener('load', function () { sc.layout(); });

  // The engine already measures every act (document top, height, progress), so
  // the loop reads those records instead of asking the layout every frame.
  var actOf = function (el) { for (var i = 0; i < sc.acts.length; i++) if (sc.acts[i].el === el) return sc.acts[i]; return null; };

  // ------------------------------------------------------------ data ----
  var DATA = null, list = null, filterKey = 'all';
  var hero = $('.msx-hero'), scene = $('[data-msx-scene]');
  var shelf = $('#msx-shelf'), rail = $('[data-msx-rail]'), books = $$('.msx-book');
  var riffle = $('#msx-riffle'), rStage = $('[data-msx-riffle]');
  var inside = $('#msx-inside'), close = $('#msx-buy');
  var index = $('[data-msx-index]'), tabs = $$('a[data-b]', index);
  var A = { hero: actOf(hero), shelf: actOf(shelf), riffle: actOf(riffle), close: actOf(close) };
  var shelfGeo = null;   // rail overflow and each book's centre inside the rail
  function measureShelf() {
    shelfGeo = {
      over: rail.scrollWidth - vw,
      extra: parseFloat(rail.getAttribute('data-sc-pan')) || 0,
      items: books.map(function (b) { return { el: b, left: b.offsetLeft, w: b.offsetWidth, n: +b.getAttribute('data-b') }; })
    };
  }

  function loadData() {
    if (DATA || loadData.busy) return;
    loadData.busy = true;
    var src = root.getAttribute('data-msx-data');
    if (mode === 'cdn') {
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = function () { setData(window.MSX_DATA); };
      document.head.appendChild(s);
    } else {
      fetch(src).then(function (r) { return r.json(); }).then(setData);
    }
  }
  function setData(d) {
    DATA = d;
    DATA.byBook = {};
    d.books.forEach(function (b) { DATA.byBook[b.b] = b; });
    DATA.gname = {};
    d.grains.forEach(function (g) { DATA.gname[g.k] = g.name; });
    applyFilter(filterKey);
  }

  // ------------------------------------------------------------ hero ----
  // Four planes at different depths. Scroll separates them at different rates
  // (far lags most, the loose page overtakes the books); a fine pointer leans
  // the whole counter a little. Ratios between planes are what read as depth.
  var planes = $$('.msx-plane', scene).map(function (el) {
    var d = el.getAttribute('data-depth');
    var cfg = { far: [0.30, 10], mid: [0.17, 16], focal: [0.08, 24], near: [-0.22, 38] }[d];
    return { el: el, d: d, lag: cfg[0], lean: cfg[1] };
  });
  var midPlane = $('.msx-plane--mid', scene);
  var px = 0, py = 0, tx = 0, ty = 0;
  if (fine && !reduce) {
    hero.addEventListener('pointermove', function (e) {
      tx = (e.clientX / vw - 0.5) * 2; ty = (e.clientY / vh - 0.5) * 2;
    });
    hero.addEventListener('pointerleave', function () { tx = 0; ty = 0; });
  }
  function drawHero(y) {
    var top = A.hero.top, h = A.hero.height;
    if (y > top + h) return;
    // 0 on landing, 1 once the hero's bottom edge reaches the top of the screen
    var hp = clamp01(y / Math.max(top + h, 1));
    px += (tx - px) * 0.08; py += (ty - py) * 0.08;
    var travel = h * hp;
    for (var i = 0; i < planes.length; i++) {
      var P = planes[i];
      var x = reduce ? 0 : -px * P.lean, yy = reduce ? 0 : travel * P.lag - py * P.lean * 0.5;
      P.el.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + yy.toFixed(2) + 'px,0)';
    }
    // the pile starts to open into a row as you leave it: scattered becomes ordered
    if (midPlane && !reduce) midPlane.style.setProperty('--fan', (hp * 1.6).toFixed(3));
  }

  // ----------------------------------------------------------- shelf ----
  function drawShelf() {
    if (!shelfGeo) measureShelf();
    var G = shelfGeo, shift = !reduce && G.over > 0 ? (G.over * (1 + G.extra)) * A.shelf.p : 0;
    var mid = vw / 2, best = 0, bestD = 1e9;
    for (var i = 0; i < G.items.length; i++) {
      var it = G.items[i], left = it.left - shift, d = Math.abs(left + it.w / 2 - mid);
      if (d < bestD) { bestD = d; best = it.n; }
      if (!reduce) {
        // items arrive in sequence like a drawer being pulled, never fully faded
        var s = clamp01((vw * 1.02 - left) / (vw * 0.32));
        if (s !== it.s) {
          it.s = s;
          it.el.style.setProperty('--settle-o', (0.55 + 0.45 * s).toFixed(3));
          it.el.style.setProperty('--settle-y', ((1 - s) * 16).toFixed(1) + 'px');
        }
      }
    }
    return best;
  }
  // jump: park the rail so that book sits in the middle of the screen
  function shelfYFor(b) {
    if (reduce) return $('#msx-book-' + b).getBoundingClientRect().top + scrollY - vh * 0.15;
    measureShelf();
    var G = shelfGeo, it = G.items[b - 1];
    var top = A.shelf.top, travel = Math.max(A.shelf.height - vh, 1);
    if (G.over <= 0) return top;
    var p = clamp01((it.left + it.w / 2 - vw / 2) / (G.over * (1 + G.extra)));
    return top + p * travel;
  }
  tabs.forEach(function (a) {
    a.addEventListener('click', function (e) {
      // the store theme animates every #link to its target; keep it out of these
      e.preventDefault(); e.stopPropagation();
      scrollTo({ top: shelfYFor(+a.getAttribute('data-b')), behavior: 'instant' });
    });
  });
  var buyTab = $('.msx-index__buy', index);
  buyTab.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    scrollTo({ top: A.close.top + Math.max(A.close.height - vh, 0), behavior: 'instant' });
    var btn = $('.msx-plate__form .msx-btn');
    if (btn) btn.focus({ preventScroll: true });
  });

  // --------------------------------------------------------- picker ----
  var grainBtns = $$('.msx-grain');
  var pick = $('[data-msx-pick]');
  function applyFilter(k) {
    filterKey = k;
    grainBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-g') === k)); });
    if (!DATA) return;
    list = k === 'all' ? DATA.recipes : DATA.recipes.filter(function (r) { return r.g.indexOf(k) > -1; });
    $('[data-msx-total]').textContent = list.length;
    $('[data-msx-filter]').textContent = k === 'all' ? 'all millets' : DATA.gname[k] + ' recipes only';
    if (k === 'all') { pick.hidden = true; }
    else {
      pick.hidden = false;
      pick.textContent = 'Your pick: ' + DATA.gname[k] + '. ' + list.length + ' ' + DATA.gname[k].toLowerCase() + ' recipes are inside.';
    }
    R.idx = -1;
  }
  grainBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      loadData();
      applyFilter(b.getAttribute('data-g'));
    });
  });

  // --------------------------------------------------------- riffle ----
  // Scroll is the thumb on the page edge. Every dish in the set (or in the
  // chosen millet) gets an equal slice of the act; low-resolution sheets carry
  // the flicking, and the dish you stop on is fetched sharp.
  var R = {
    canvas: $('.msx-riffle__canvas'), sharp: $('[data-msx-sharp]'), poster: $('[data-msx-poster]'),
    frame: $('.msx-riffle__frame'), num: $('[data-msx-num]'), name: $('[data-msx-name]'),
    bno: $('[data-msx-bno]'), btitle: $('[data-msx-btitle]'), meta: $('[data-msx-meta]'), thumb: $('[data-msx-thumb]'),
    idx: -1, lastP: 0, vel: 0, sheets: {}, drawn: -1, sharpFor: 0, sharpTimer: 0
  };
  root.__msxRiffle = R;
  R.ctx = R.canvas.getContext('2d', { alpha: false });
  function sizeCanvas() {
    var r = R.frame.getBoundingClientRect(), dpr = Math.min(devicePixelRatio || 1, 2);
    R.canvas.width = Math.max(1, Math.round(r.width * dpr));
    R.canvas.height = Math.max(1, Math.round(r.height * dpr));
    R.drawn = -1;
  }
  sizeCanvas();
  // Sheets on Shopify are 720x480 frames that the CDN scales down: 180x120 a
  // frame is plenty while flicking, and the dish you stop on is fetched sharp.
  function lo() { return mode === 'cdn' ? [180, 120] : DATA.lo; }
  function sheetUrl(b) {
    if (mode !== 'cdn') return 'assets/lo/b' + b + '.webp';
    var u = sheetsCdn[b];
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (DATA.cols * lo()[0]);
  }
  function hdUrl(rec) {
    if (mode !== 'cdn') return 'assets/hd/' + rec.n + '.webp';
    var bk = DATA.byBook[rec.b], k = rec.n - bk.first, u = sheetsCdn[rec.b];
    var x = (k % DATA.cols) * DATA.hd[0], y = Math.floor(k / DATA.cols) * DATA.hd[1];
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'crop=region&crop_left=' + x + '&crop_top=' + y +
      '&crop_width=' + DATA.hd[0] + '&crop_height=' + DATA.hd[1] + '&width=' + DATA.hd[0];
  }
  function loadSheet(b) {
    if (R.sheets[b]) return R.sheets[b];
    var im = new Image();
    im.decoding = 'async';
    im.onload = function () { im.ok = true; R.drawn = -1; };
    im.src = sheetUrl(b);
    R.sheets[b] = im;
    return im;
  }
  function warmSheets(fromBook) {
    // the book under the thumb first, then outwards in reading order
    for (var d = 0; d < 11; d++) {
      var b = ((fromBook - 1 + d) % 11) + 1;
      var s = R.sheets[b];
      if (!s) { loadSheet(b); return; }
      if (!s.ok) return;
    }
  }
  function drawFrame(rec) {
    var bk = DATA.byBook[rec.b], s = loadSheet(rec.b);
    if (!s.ok) {
      if (R.live) { R.ctx.fillStyle = '#1a0f0a'; R.ctx.fillRect(0, 0, R.canvas.width, R.canvas.height); }
      return false;
    }
    var k = rec.n - bk.first, fw = lo()[0], fh = lo()[1];
    R.ctx.drawImage(s, (k % DATA.cols) * fw, Math.floor(k / DATA.cols) * fh, fw, fh, 0, 0, R.canvas.width, R.canvas.height);
    if (!R.live) { R.live = true; R.frame.classList.add('is-live'); }
    return true;
  }
  function label(rec, i) {
    var bk = DATA.byBook[rec.b];
    R.num.textContent = i + 1;
    R.name.textContent = rec.t;
    R.bno.textContent = 'Book ' + (rec.b < 10 ? '0' : '') + rec.b;
    R.btitle.textContent = bk.title;
    R.meta.textContent = rec.g.map(function (k) { return DATA.gname[k]; }).join(' + ') + ' · ' + rec.w + ' · ' + rec.m;
    var t = $('.msx-book[data-b="' + rec.b + '"] img');
    if (t && R.thumb.getAttribute('data-b') !== String(rec.b)) { R.thumb.src = t.currentSrc || t.src; R.thumb.setAttribute('data-b', rec.b); }
  }
  function sharpen() {
    var rec = list && list[R.idx];
    if (!rec || R.sharpFor === rec.n) return;
    R.sharpFor = rec.n;
    var im = new Image(), want = rec.n;
    im.onload = function () {
      if (R.sharpFor !== want) return;
      R.sharp.src = im.src;
      R.sharp.classList.add('is-on');
    };
    im.src = hdUrl(rec);
  }
  function drawRiffle(t) {
    var p = A.riffle.p;
    if (!DATA || !list) return 0;
    var N = list.length, pos = p * N;
    var i = Math.min(N - 1, Math.floor(pos));
    var f = pos - Math.floor(pos);
    var dp = Math.abs(pos - R.lastP); R.lastP = pos;
    R.vel += (Math.min(dp, 3) - R.vel) * 0.25;
    var rec = list[i];
    warmSheets(rec.b);
    if (i !== R.idx) {
      R.idx = i; R.sharpFor = 0;
      R.sharp.classList.remove('is-on');
      label(rec, i);
      rStage.setAttribute('data-sc-verify-state', String(i));
    }
    if (R.drawn !== i && drawFrame(rec)) R.drawn = i;
    // the moment the hand stops on a dish, fetch that dish sharp
    if (dp > 0.002 || !R.sharpTimer) {
      clearTimeout(R.sharpTimer);
      R.sharpTimer = setTimeout(sharpen, 140);
    }
    if (!reduce) {
      R.frame.style.setProperty('--f', f.toFixed(3));
      R.frame.style.setProperty('--v', Math.min(1, R.vel * 2.5).toFixed(3));
    }
    return rec.b;
  }

  // ------------------------------------------------------------ loop ----
  var lastTab = 0;
  function setTab(b) {
    if (b === lastTab) return;
    lastTab = b;
    tabs.forEach(function (a) { a.classList.toggle('is-active', +a.getAttribute('data-b') === b); });
  }
  function inView(a, y, pad) {
    return y + vh > a.top - (pad || 0) && y < a.top + a.height + (pad || 0);
  }
  var indexOn = null;
  function frame(t) {
    var y = scrollY;
    drawHero(y);
    var b = 0;
    if (inView(A.shelf, y)) b = drawShelf();
    if (inView(A.riffle, y, vh * 2)) loadData();
    if (inView(A.riffle, y)) { var rb = drawRiffle(t); if (rb && A.riffle.top - y < vh * 0.5) b = rb; }
    setTab(b);
    var on = A.shelf.top - y < vh * 0.6 && A.close.top - y > vh * 0.5;
    if (on !== indexOn) { indexOn = on; index.classList.toggle('is-on', on); }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  addEventListener('resize', function () { vh = innerHeight; vw = innerWidth; headerOffset(); sizeCanvas(); shelfGeo = null; });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { shelfGeo = null; });

  // ------------------------------------------------------------ cart ----
  $$('[data-msx-cart]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (mode !== 'cdn') { e.preventDefault(); f.querySelector('button').textContent = 'Added (local preview)'; return; }
      f.querySelector('button').disabled = true;
    });
  });
  // a cart form restored from the back/forward cache must be usable again
  addEventListener('pageshow', function () { $$('[data-msx-cart] button').forEach(function (b) { b.disabled = false; }); });

  if ('requestIdleCallback' in window) requestIdleCallback(loadData, { timeout: 4000 }); else setTimeout(loadData, 2500);
})();
